import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { Input, InputNumber, Table } from "antd";
import SelectSearchable from "../../SelectSeachble/SelectSearchble";
import { useCallback, useEffect, useState } from "react";
import { ControllerListarSegurosClinica } from "../../../Service/Services.seguros";
import { GetTokenDecoded } from "../../../utils/storeUsuario";
import { ListarProcedimientoConPrecios } from "../../../Service/Service.examen";
import Swal from "sweetalert2";
import TypedInputNumber from "antd/es/input-number";
import { ListCategoriaExamen } from "../../../Service/Service.categoriaExamen";
import { PostNewPlan, PutUpdatePlan } from "../../../Service/Service.Plan";
import { calcularMontosCobertura } from "../../../utils/copagoCalculo";

function PlanPrecioNuevo({ data }) {

    // comentando para editar plan 
    //const { show, handleClose } = data;

    const { show, handleClose, planSeleccionado } = data;
    
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [seguros, setSeguros] = useState([]);
    const [selectedSeguroOption, setSelectedSeguroOption] = useState(null);
    const [tipoExamen, setTipoExamen] = useState([]);
    const [selectedTipoExamenteOption, setSelectedTipoExamenOption] = useState(null);

    const [listarProcedimientos, setListarProcedimientos] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedProcedimientos, setSelectedProcedimientos] = useState([]);
    const [nombrePlan, setNombrePlan] = useState("");

    const [copagoGlobal, setCopagoGlobal] = useState(null);
    const [aplicarCopagoGlobal, setAplicarCopagoGlobal] = useState(false);

    /* para editar plan */
    const [originalProcedimientosIds, setOriginalProcedimientosIds] = useState([]);

    const columns = [
        {
            title: 'Código',
            dataIndex: ['ExamenTipo', 'codigo'],
            key: 'codigo',
            width: 80,
        },
        {
            title: 'Descripción',
            dataIndex: ['ExamenTipo', 'descripcion'],
            key: 'ExamenTipo.descripcion',
            width: 150,
        },
        {
            title: 'Precio',
            dataIndex: 'precio',
            key: 'precio',
            width: 80,
            align: 'right',
            render: (_, record) => (<>{record.precio.toFixed(2)}</>),
        },
        {
            title: 'Seguro',
            dataIndex: ['Seguros', 'nombre'],
            key: 'nombre',
            width: 100,
        },
        {
            title: '% Copago',
            dataIndex: 'copago',
            key: 'copago',
            width: 100,
            align: 'right',
            render: (_, record) => {
                const selectedRecord = selectedProcedimientos.find(p => p.idprocedimiento_company_precios === record.idprocedimiento_company_precios) || record;

                return (
                    <TypedInputNumber
                        min={0}
                        precision={0}
                        size="small"
                        value={selectedRecord.copago}
                        onChange={(value) => handleCopagoChange(value, record)}
                        disabled={!selectedRowKeys.includes(record.idprocedimiento_company_precios)}

                    />
                );
            },
        }, 
        {
            title: 'VP',
            dataIndex: 'valor_paciente',
            key: 'valor_paciente',
            width: 80,
            align: 'right',
            render: (_, record) => {
                const selectedRecord = selectedProcedimientos.find(p => p.idprocedimiento_company_precios === record.idprocedimiento_company_precios) || record;
                return <>{selectedRecord.valor_paciente?.toFixed(2)}</>;
            },
        },
        {
            title: 'VE',
            dataIndex: 'valor_empresa',
            key: 'valor_empresa',
            width: 80,
            align: 'right',
            render: (_, record) => {
                const selectedRecord = selectedProcedimientos.find(p => p.idprocedimiento_company_precios === record.idprocedimiento_company_precios) || record;
                return <>{selectedRecord.valor_empresa?.toFixed(2)}</>;
            },
        },                          
    ];

    const handleCopagoChange = (value, record) => {
        setSelectedProcedimientos(prev => 
            prev.map(p => 
                p.idprocedimiento_company_precios === record.idprocedimiento_company_precios
                    ? {
                        ...p,
                        copago: value,
                        valor_empresa: calcularMontosCobertura(p.precio, value).precioEmpresa,
                        valor_paciente: calcularMontosCobertura(p.precio, value).precioPaciente
                    }
                    : p
            )
        );        
    };

    useEffect(() => {
        if (aplicarCopagoGlobal) {
          // Aplica el copago ingresado a todos los seleccionados
          setSelectedProcedimientos(prev =>
            prev.map(p => ({
              ...p,
              copago: copagoGlobal ?? 0,
              valor_empresa: calcularMontosCobertura(p.precio, copagoGlobal ?? 0).precioEmpresa,
              valor_paciente: calcularMontosCobertura(p.precio, copagoGlobal ?? 0).precioPaciente,
            }))
          );
        } else {
          // Si desmarcan el checkbox, dejar copago en 0
          setSelectedProcedimientos(prev =>
            prev.map(p => ({
              ...p,
              copago: 0,
              valor_empresa: p.precio,
              valor_paciente: 0,
            }))
          );
        }
      }, [copagoGlobal, aplicarCopagoGlobal]);
      
    const handleChangeSeguro = selectedSeguroOption => {
        setSelectedSeguroOption(selectedSeguroOption);
        fetchProcedimientos(selectedSeguroOption.value, selectedTipoExamenteOption.value);
        // setSelectedRowKeys([]);
        // setSelectedProcedimientos([]);
    };

    const handleChangeTipoExamen = selectedSExamenOption => {
        setSelectedTipoExamenOption(selectedSExamenOption);
        fetchProcedimientos(selectedSeguroOption.value, selectedSExamenOption.value);
        // setSelectedRowKeys([]);
        // setSelectedProcedimientos([]);
    };

    const onRowSelectionChangeNuevo = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedProcedimientos(prev => {
            return selectedRows.map(row => {
                const existing = prev.find(p => p.idprocedimiento_company_precios === row.idprocedimiento_company_precios);
                return existing ? existing : { ...row, precio_promocion: row.precio_promocion ?? "" };
            });
        });
    };

    const rowSelectionNuevo = {
        selectedRowKeys,
        onChange: onRowSelectionChangeNuevo,
        preserveSelectedRowKeys: true,
    };


    const handleSearch = (value) => {
        setSearchText(value);
    };

    const filteredData = listarProcedimientos.filter((proc) =>
        proc.ExamenTipo.codigo.toLowerCase().includes(searchText.toLowerCase()) ||
        proc.ExamenTipo.descripcion.toLowerCase().includes(searchText.toLowerCase())
    );

    // TARIFARIOS-PERF-02: aseguradora Y categoria las filtra el SERVIDOR.
    // Antes se pedia el tarifario COMPLETO (9.590 filas / 4,32 MB) para
    // quedarse con una combinacion (seguro, categoria) que en promedio son
    // 107 filas -- se descartaba el 99 %. Mismas filas en pantalla.
    const fetchProcedimientos = useCallback(async (seguroId, tipoExamenId) => {
        setLoading(true);
        const response = await ListarProcedimientoConPrecios({
            seguro_id: seguroId,
            categoria_id: tipoExamenId,
        });
        if (response.success) {
            setListarProcedimientos(response.data || []);
        }
        // Antes `setLoading(false)` estaba DENTRO del `if`: si la peticion
        // fallaba, el modal se quedaba cargando para siempre.
        setLoading(false);
    }, []);

    const fetchInitialData = useCallback(async () => {
        const dataSeguro = await ControllerListarSegurosClinica(GetTokenDecoded().idclinica);
        const segurosFiltrados = dataSeguro.filter(seg => seg.tipoSeguro.tipo === "SEGUROS");
        const segurosOptions = segurosFiltrados.map((seg) => ({ value: seg.idseguro, label: seg.nombre }));
        setSeguros(segurosOptions);

        if (segurosOptions.length > 0) {
            setSelectedSeguroOption(segurosOptions[0]);
        }

        const dataTipoExamen = await ListCategoriaExamen();
        const tipoExamenes = dataTipoExamen.data.map((seg) => ({ value: seg.IdCategoriaExamen, label: seg.Descripcion }));
        setTipoExamen(tipoExamenes);

        if (tipoExamenes.length > 0) {
            setSelectedTipoExamenOption(tipoExamenes[0]);
        }

        fetchProcedimientos(segurosOptions[0].value, tipoExamenes[0].value);

    }, [fetchProcedimientos]);


    useEffect(() => {
        if (show) {
            fetchInitialData();
        }
    }, [fetchInitialData, show]);

    useEffect(() => {
        if (show && planSeleccionado) {
            // Cargar nombre del plan
            setNombrePlan(planSeleccionado.nombre);
    
            // Cargar seguro
            setSelectedSeguroOption({
                value: planSeleccionado.Seguros.idseguro,
                label: planSeleccionado.Seguros.nombre
            });
    
            // Cargar detalles
            const detalles = planSeleccionado.detalles.map(d => {
                // COBERTURAS-COPAGO-CALCULO-AUDIT-FIX-01: reparto DERIVADO de (copago, tarifa).
                const m = calcularMontosCobertura(d.tarifario.precio, d.copago);
                return {
                    ...d,
                    idExamenTipo: d.ExamenTipo.idExamenTipo,
                    precio: d.tarifario.precio,
                    valor_paciente: m.precioPaciente,
                    valor_empresa: m.precioEmpresa,
                    idprocedimiento_company_precios: d.idprocedimiento_company_precios
                };
            });
    
            setSelectedProcedimientos(detalles);
            setSelectedRowKeys(detalles.map(d => d.idprocedimiento_company_precios));
            setOriginalProcedimientosIds(detalles.map(d => d.idprocedimiento_company_precios)); // 👈 este es el objetivo de este paso
        }
    }, [show, planSeleccionado]);
    
    /* comentado para editar planes
    const handleAgregarPlan = async () => {
        try {

            const procedimientosInvalidos = selectedProcedimientos.some(ex =>
                ex.copago === null ||
                ex.copago === undefined ||
                ex.copago === ""
            );

            if (procedimientosInvalidos) {
                Swal.fire({
                    icon: "warning",
                    title: "Advertencia",
                    text: "Todos los procedimientos seleccionados deben tener un copago válido.",
                });
                return;
            }
            setLoading(true);
            const payload = {
                cabecera: {
                    nombre: nombrePlan,
                    seguro_id: selectedSeguroOption.value
                },
                detalle: selectedProcedimientos.map(ex => ({
                    id_tipo_examen: ex.idExamenTipo,
                    copago: ex.copago,
                    precio_paciente: ex.valor_paciente,
                    precio_empresa: ex.valor_empresa,
                    idprocedimiento_company_precios: ex.idprocedimiento_company_precios
                }))
            }

            const response = await PostNewPlan(payload);
            if (!response.success) {
                throw new Error(response.message);
            }

            setSelectedRowKeys([]);
            setSelectedProcedimientos([]);
            setNombrePlan("")

            handleClose();
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                showConfirmButton: true,
            });

        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al crear el plan",
            });

        } finally {
            setLoading(false);
        }
    };*/

    const handleAgregarPlan = async () => {
        try {
            const procedimientosInvalidos = selectedProcedimientos.some(ex =>
                ex.copago === null ||
                ex.copago === undefined ||
                ex.copago === ""
            );
    
            if (procedimientosInvalidos) {
                Swal.fire({
                    icon: "warning",
                    title: "Advertencia",
                    text: "Todos los procedimientos seleccionados deben tener un copago válido.",
                });
                return;
            }
    
            setLoading(true);
    
            const payloadBase = {
                cabecera: {
                    nombre: nombrePlan,
                    seguro_id: selectedSeguroOption.value
                },
                detalle: selectedProcedimientos.map(ex => ({
                    id_tipo_examen: ex.idExamenTipo,
                    copago: ex.copago,
                    precio_paciente: ex.valor_paciente,
                    precio_empresa: ex.valor_empresa,
                    idprocedimiento_company_precios: ex.idprocedimiento_company_precios
                }))
            };
    
            let response;
    
            if (planSeleccionado) {
                // Modo edición
                const idsSeleccionados = selectedProcedimientos.map(p => p.idprocedimiento_company_precios);
                const idsAEliminar = originalProcedimientosIds.filter(id => !idsSeleccionados.includes(id));
    
                const payload = {
                    ...payloadBase,
                    eliminar: idsAEliminar
                };
    
                response = await PutUpdatePlan(planSeleccionado.idplan, payload);
            } else {
                // Modo creación
                response = await PostNewPlan(payloadBase);
            }
    
            if (!response.success) {
                throw new Error(response.message);
            }
    
            // Limpiar campos
            setSelectedRowKeys([]);
            setSelectedProcedimientos([]);
            setNombrePlan("");
    
            handleClose();
    
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                showConfirmButton: true,
            });
    
        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al guardar el plan",
            });
    
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Crear Plan</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col>
                        <div className="d-flex w-100 justify-content-between align-items-center pb-2">
                            <Input
                                placeholder="Buscar por código o descripción"
                                value={searchText}
                                onChange={(e) => handleSearch(e.target.value)}
                                className="me-2 w-50"
                            />

                            <div className="w-auto me-2">
                                <SelectSearchable
                                    listCompany={seguros}
                                    handleChange={handleChangeSeguro}
                                    selectedOption={selectedSeguroOption}
                                    placeholder="Seleccione"
                                />
                            </div>
                            <div className="w-auto">
                                <SelectSearchable
                                    listCompany={tipoExamen}
                                    handleChange={handleChangeTipoExamen}
                                    selectedOption={selectedTipoExamenteOption}
                                    placeholder="Seleccione"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>

                    <div className="d-flex align-items-center mb-2">
                        <InputNumber
                            min={0}
                            max={100}
                            value={copagoGlobal}
                            onChange={(value) => setCopagoGlobal(value)}
                            placeholder="% Copago general"
                            style={{ marginRight: '10px', width: '120px' }}
                        />
                        <label className="form-check-label d-flex align-items-center">
                            <input
                            type="checkbox"
                            className="form-check-input me-1"
                            checked={aplicarCopagoGlobal}
                            onChange={(e) => setAplicarCopagoGlobal(e.target.checked)}
                            />
                            Aplicar a todos los seleccionados
                        </label>
                        </div>

                        <Table dataSource={searchText ? filteredData : listarProcedimientos}
                            columns={columns}
                            size='small'
                            scroll={{ x: "max-content", y: 250 }}
                            rowSelection={rowSelectionNuevo}
                            rowKey={(record) => record.idprocedimiento_company_precios}
                            loading={loading} />

                    </Col>
                </Row>

            </Modal.Body>

            <Modal.Footer>
                <div className="d-flex w-100 justify-content-between align-items-center">
                    <Input
                        placeholder="Nombre del Plan"
                        value={nombrePlan}
                        className="w-75"
                        onChange={(e) => setNombrePlan(e.target.value)}
                    />

                    <button className="btn btn-primary" onClick={handleAgregarPlan} disabled={loading || !nombrePlan || !selectedProcedimientos.length}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) : "Crear"}
                    </button>
                </div>
            </Modal.Footer>

        </Modal>
    )

}

export default PlanPrecioNuevo;